import { AxiosResponse } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';
const ROUTE = 'auth';

export interface LoginAuthResponse {
    token: string;
    refreshToken: string;
}

const login = (email: string, password: string): Promise<AxiosResponse<LoginAuthResponse>> => {
    return EndPointService.post(`/${ROUTE}/sign-in`, { email, password });
};
const refresh = (refreshToken: any): Promise<AxiosResponse<LoginAuthResponse>> => {
    return EndPointService.post(`/${ROUTE}/refresh`, { refreshToken });
};

export default {
    login,
    refresh,
};
